import React, { useState, useEffect, useCallback } from "react";
import CommandPalette, { filterItems, getItemIndex, useHandleOpenCommandPalette } from "src/cmdk";
import { CmdkAiContainer } from "./ai/container";
import { CmdkAiTextInput } from "./ai/text-input";
import TextPalette from "./components/TextPalette";

import { useCmdkStore, CMDK_PAGE_IDS } from "./store";

export type PageType = "root" | "create-journey-for-another-company" | "create-journey-about-company" | "create-journey-about-topic" | "create-section-about";

export const CmdkTextCommands = () => {
  const { textOpen, textLoading, setTextOpen, resetText, updateTextContent, runLastTextAction, runActionOnExistingText } = useCmdkStore();

  const onClose = () => {
    setTextOpen(false);
    resetText();    
  };

  const onUseResult = () => {
    updateTextContent();
    onClose();
  };

  const onTryAgain = () => {
    runLastTextAction();
  };

  const onLengthen = () => {
    runActionOnExistingText('lengthen');
  };

  const onShorten = () => {
    runActionOnExistingText('shorten');
  };

  const onDiscard = onClose;

  return (
    <TextPalette
      isOpen={textOpen}
      textLoading={textLoading}
      onClose={onClose}
      onDiscard={onDiscard}
      onUseResult={onUseResult}
      onTryAgain={onTryAgain}
      onLengthen={onLengthen}
      onShorten={onShorten}
    />
  );
};